"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePersonalAutoDiscountSchema = void 0;
const Discount_1 = require("./Discount");
const PersonalAutoDiscountTypes_1 = require("./PersonalAutoDiscountTypes");
exports.impossiblePersonalAutoDiscountSchema = Discount_1.impossibleDiscountSchema.extend({
    name: PersonalAutoDiscountTypes_1.impossiblePersonalAutoDiscountType,
}).strict();
